import axios from 'axios';
import headers from '../constants/headers';

axios.defaults.headers.common.Authorization = `Bearer ${headers.access_token}`;

const citizensService = {
  getCitizens() {
    return axios.get('interesteds/citizens');
  },
  createCitizen(payload) {
    return axios.post('interesteds/citizens', payload);
  },
};

export default citizensService;



// WEBPACK FOOTER //
// ./src/services/CitizensService.js